import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgMoneyInvoice = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M18.4141 12.6326V3.46968C18.4141 3.12676 18.2778 2.79788 18.0354 2.5554C17.7929 2.31292 17.464 2.1767 17.1211 2.1767H6.77723C6.43431 2.1767 6.10544 2.31292 5.86296 2.5554C5.62048 2.79788 5.48425 3.12676 5.48425 3.46968V12.6326"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.9519 11.413C20.0471 11.3375 20.1616 11.2903 20.2824 11.277C20.4031 11.2636 20.5252 11.2845 20.6346 11.3373C20.744 11.3901 20.8363 11.4727 20.901 11.5756C20.9656 11.6785 21 11.7975 21.0001 11.9189V20.2802C21.0001 20.6232 20.8638 20.952 20.6214 21.1945C20.3789 21.437 20.05 21.5732 19.7071 21.5732H4.1913C3.84838 21.5732 3.5195 21.437 3.27702 21.1945C3.03454 20.952 2.89832 20.6232 2.89832 20.2802V11.9189C2.89842 11.7975 2.93276 11.6785 2.9974 11.5756C3.06203 11.4727 3.15435 11.3901 3.26376 11.3373C3.37317 11.2845 3.49525 11.2636 3.616 11.277C3.73676 11.2903 3.8513 11.3375 3.94649 11.413L10.3519 16.4935C10.8075 16.8513 11.3699 17.0458 11.9492 17.0458C12.5284 17.0458 13.0909 16.8513 13.5465 16.4935L19.9519 11.413Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.2316 15.1566L17.7675 17.6926"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.66671 15.1566L6.13074 17.6926"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.1216 10.2312C12.3083 10.4763 12.5513 10.6729 12.8301 10.8042C13.1089 10.9355 13.4153 10.9977 13.7232 10.9854C14.705 10.9854 15.5015 10.388 15.5015 9.6519C15.5015 8.91576 14.7076 8.31926 13.7266 8.31926C12.7457 8.31926 11.9492 7.72191 11.9492 6.98491C11.9492 6.24791 12.7457 5.65141 13.7266 5.65141C14.0346 5.63893 14.341 5.70098 14.6198 5.8323C14.8987 5.96361 15.1417 6.1603 15.3282 6.40565"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.7266 10.9854V11.8741"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.7266 4.76262V5.65133"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.07019 5.40921H9.36317"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.07019 7.99513H9.36317"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.07019 10.5811H9.36317"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgMoneyInvoice.displayName = 'SvgMoneyInvoice';
export default SvgMoneyInvoice;
